import { __awaiter } from "tslib";
import { ObjectProcessingNode } from '../../ObjectProcessingNode';
import { TimeService } from '../../../service/TimeService';
/**
 * @category Processing node
 */
export class PropertyFilterProcessingNode extends ObjectProcessingNode {
  constructor(propertySelector, propertyModifier, options) {
    super(options);
    this._propertySelector = propertySelector;
    this._propertyModifier = propertyModifier;
  }
  processObject(object, frame) {
    return new Promise((resolve, reject) => {
      // Extract all sensor values from the frame
      const types = this._propertySelector(object, frame);
      Promise.all(types.map(type => {
        return this.filterValue(object, type.value, type.key);
      })).then(results => {
        for (let i = 0; i < results.length; i++) {
          const result = results[i];
          const type = types[i];
          this._propertyModifier(type.key, result, object, frame);
        }
        resolve(object);
      }).catch(reject);
    });
  }
  filterValue(object, value, key = 'default') {
    return new Promise((resolve, reject) => {
      // Get existing filter data
      this.getNodeData(object).then(nodeData => __awaiter(this, void 0, void 0, function* () {
        if (nodeData === undefined) {
          nodeData = {};
        }
        const currentTimestamp = TimeService.now();
        if (nodeData[key] === undefined) {
          nodeData[key] = Object.assign({
            timestamp: currentTimestamp
          }, yield this.initFilter(object, value, this.options));
        } else {
          nodeData[key] = Object.assign({
            timestamp: currentTimestamp
          }, nodeData[key]);
        }
        if (this.options.expire) {
          const deleteData = [];
          Object.keys(nodeData).forEach(key => {
            const data = nodeData[key];
            if (data['timestamp']) {
              if (data.timestamp + this.options.expire < currentTimestamp) {
                deleteData.push(key);
              }
            }
          });
          deleteData.forEach(key => {
            delete nodeData[key];
          });
        }
        this.filter(object, value, nodeData[key], this.options).then(resolve).catch(reject).finally(() => {
          this.setNodeData(object, nodeData);
        });
      })).catch(reject);
    });
  }
}